<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import layout from '@/layout/page-with-header'
const components = {
  layout,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
    profile: {},
    account: {},
    isProfileLocked: true,
  }
}

/**
 * Computed
 *
 */
const computed = {
  ...mapGetters({
    isLoading: `Product/Item/loadingState`,
    data: `Product/Item/data`,
    brandOptions: `Product/Brand/options`,
    categoryOptions: `Product/Category/options`,
    supplierOptions: `Product/Supplier/options`,
  }),
}

/**
 * Methods
 *
 */
const methods = mapActions({
  fetchData: `Product/Item/fetchData`,
  updateData: `Product/Item/update`
})

methods.profileMode = function(mode) {
  if (mode === `edit`) this.isProfileLocked = false
  if (mode === `revert`) this.reset()
}

methods.goback = function() {
  this.$router.push(`/product/item`)
}

methods.reset = function() {
  this.profile = Object.assign({}, this.data)
  this.isProfileLocked = true
}

methods.updateProfile = async function() {
  const data = this.profile
  data.store_discount = data.price_unit - data.price_store

  await this.updateData({
    id: this.data.id,
    data,
  })

  this.goback()
}

/**
 * Event OnMounted
 *
 */
const mounted = function() {
  const id = this.$route.params.id
  Promise.resolve()
    .then(() => this.fetchData(id))
    .then(() => this.reset())
    .then(() => this.$store.commit(`add_breadcrumb`, this.profile.name))
}

/**
 * Event OnCreated
 *
 */
const created = function() {
  this.$store.commit(`set_page_title`, `Manajemen Toko`)
  this.$store.commit(`set_breadcrumb`, [ `Data Barang`, `List` ])
}

export default {
  components,
  data,
  computed,
  methods,
  mounted,
  created,
}
</script>

<template>
  <layout type="narrow">
    <Row>
      <Col12>
        <h2 class="content-heading">Setting Data Barang</h2>
      </Col12>

      <BlockForm title="DETAIL PRODUK"
        :width=6
        :loadingState="isLoading"
        :editbutton=false
        :lockedState=false>
        <template #content>
          <FormGroup>
            <SelectField
              label="Kategori"
              width="8"
              :options="categoryOptions"
              defaultLabel="-- Pilih Kategori --"
              defaultValue=""
              v-model="profile.category_id" />

            <TextField
              label="Nama Barang"
              width="8"
              :forceupper=true
              v-model="profile.name" />

            <TextArea
              label="Deskripsi"
              width="12"
              v-model="profile.description" />

            <SelectField
              label="Brand"
              width="8"
              :options="brandOptions"
              defaultLabel="-- Pilih Brand --"
              defaultValue=""
              v-model="profile.brand_id" />

            <TextField
              label="Stok Balance"
              width="4"
              :forceupper=true
              v-model="profile.minimum_stock" />

            <SelectField
              label="Supplier"
              width="8"
              :options="supplierOptions"
              defaultLabel="-- Pilih Supplier --"
              defaultValue=""
              v-model="profile.supplier_id" />
          </FormGroup>
        </template>
      </BlockForm>

      <BlockForm title="SETTING HARGA"
        :width=6
        :loadingState="isLoading"
        :editbutton=false
        :lockedState=false>
        <template #content>
          <FormGroup>
            <TextField
              label="Harga Beli"
              width="8"
              :forceupper=true
              :laddon=true
              v-model="profile.price_asset" >
              <template #before>Rp.</template>
            </TextField>

            <TextField
              label="Harga Jual ke Pelanggan"
              width="8"
              :forceupper=true
              :laddon=true
              v-model="profile.price_unit" >
              <template #before>Rp.</template>
            </TextField>

            <TextField
              label="Harga Jual ke Toko Lain"
              width="8"
              :forceupper=true
              :laddon=true
              v-model="profile.price_store" >
              <template #before>Rp.</template>
            </TextField>
<!--

            <TextField
              label="Komisi Penjualan untuk Reseller"
              width="8"
              :forceupper=true
              :laddon=true
              v-model="profile.resell_commission" >
              <template #before>Rp.</template>
            </TextField> -->
          </FormGroup>
        </template>

        <template #footer>
          <ButtonFormSet
            labelcancel="Tutup"
            @submit="updateProfile"
            @cancel="goback"
          />
        </template>
      </BlockForm>
    </Row>
  </layout>
</template>